import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { tap } from 'rxjs/operators';
import { SharedService } from '../app/Shared/Common/shared.service';
@Injectable({
  providedIn: 'root'
})
export class AreaService {
  private areasList: string[] = [];
  private storageKey = 'areasList';
  private storageExpirationKey = 'areas_expiration';
  private expirationPeriod = 7 * 24 * 60 * 60 * 1000; // 7 days in milliseconds

  constructor(private http: HttpClient, private sharedService: SharedService) {}

  async initializeApp(): Promise<void> {
    // If areas are already loaded in memory, use them
    if (this.areasList.length > 0) {
      return Promise.resolve();
    }

    return new Promise<void>((resolve, reject) => {
      const storedAreas = localStorage.getItem(this.storageKey);
      const storedExpiration = localStorage.getItem(this.storageExpirationKey);

      if (storedAreas && storedExpiration) {
        const expirationTime = Number(storedExpiration);
        if (Date.now() < expirationTime) {
          this.areasList = JSON.parse(storedAreas);
          resolve();
          return;
        }
      }

      // Fetch areas data from shared service or API
      this.sharedService.getAreasList().subscribe(
        (data) => {
          this.areasList = data;
          localStorage.setItem(this.storageKey, JSON.stringify(this.areasList));
          const expirationTime = Date.now() + this.expirationPeriod;
          localStorage.setItem(this.storageExpirationKey, expirationTime.toString());
          resolve();
        },
        (error) => {
          console.error('Error loading areas from shared service:', error);
          reject(error);
        }
      );
    });
  }

  getAreas(): string[] {
    return this.areasList;
  }
}
